// extracted by mini-css-extract-plugin
export var container = "_rz-0";
export var table = "_rz-2";
export var tableWrapper = "_rz-1";